import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { all_routes } from "../../router/all_routes";
import { useAuth } from "../../auth/AuthContext";
import useApi from "../../../core/customhook/useApi";
import Datatable from "../../../core/common/dataTable";
import { formatDate } from "../../../core/common/TabelValue";
import SnipperLoader from "../../../core/common/loader/SnipperLoader";
import { apibaseurl } from "../../../environment";
import Swal from "sweetalert2";
const InsuffRaise = () => {
  const navigate = useNavigate();
  const { authData } = useAuth();
  const candidateId = authData?.candidate?.candidateId;
  const [showDocumentsModal, setShowDocumentsModal] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState<any[]>([]);
  const [insuffHistroy, setInsuffHistory] = useState<any[]>([]);

  // ======= Modal State =============

  const [showReplyModal, setShowReplyModal] = useState(false);
  const [replyRemarks, setReplyRemarks] = useState("");
  const [replyDocuments, setReplyDocuments] = useState<File[]>([]);
  const [selectedInsuffRecord, setSelectedInsuffRecord] = useState<any>(null);

  // ======== Modal stat eend her e===============

  const insufftabel = useApi<any>(
    `/api/v1/insufficiency/check-candidate/${candidateId}`,
    {
      method: "GET",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const insuffResponse = useApi<any>(
    `/api/v1/insufficiency/candidate-response`,
    {
      method: "POST",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const getInsuffHistory = async () => {
    try {
      const res = await insufftabel.callApi();

      if (res?.success) {
        setInsuffHistory(res.data || []);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getModuleByCheckName = (checkName: string) => {
    switch (checkName) {
      case "Aadhar KYC":
        return "adharvalidation";

      case "Highest Education":
        return "firstEducationForm";

      case "2 Highest Education":
        return "lastTwoEducation";

      case "Education Documents":
        return "educationDocuments";

      case "All Education Documents":
        return "educationDocuments";

      case "Employment":
        return "employeeForm";

      case "Employment - 2 Year":
      case "Employment - 3 Year":
      case "Employment - 5 Year":
      case "Employment - 7 Year":
      case "Employment - 10 Year":
        return "employmentHistory";

      case "PAN Card":
        return "pancardForm";

      case "PAN card verification (without validation)":
        return "pancardWithoutValidation";

      case "Career Gap Comments":
        return "careerGapComments";

      case "Reference":
        return "reference";

      default:
        return "";
    }
  };

  // ========== Modal Reply to Insuff funcation ==============

  const handleReplyFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;

    setReplyDocuments(Array.from(e.target.files));
  };

  const removeReplyFile = (index: number) => {
    setReplyDocuments((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmitReply = async () => {
    if (insuffResponse.loading) return;

    if (!selectedInsuffRecord) {
      Swal.fire({
        icon: "error",
        title: "Record Not Found",
        text: "Please select an insufficiency record.",
      });
      return;
    }

    if (!replyRemarks.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Remarks Required",
        text: "Please enter your remarks before submitting.",
      });
      return;
    }

    const record = selectedInsuffRecord;
    const requiredFields = [
      "assignment_template_id",
      "assignment_id",
      "case_id",
      "candidate_id",
    ];
    const missingFields = requiredFields.filter(
      (field) =>
        record[field] === undefined ||
        record[field] === null ||
        record[field] === "",
    );

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "error",
        title: "Missing Case Details",
        text: `Missing: ${missingFields.join(", ")}`,
      });
      return;
    }

    try {
      const payload = new FormData();
      payload.append(
        "assignment_template_id",
        String(record.assignment_template_id),
      );
      payload.append("assignment_id", String(record.assignment_id));
      payload.append("case_id", String(record.case_id));
      payload.append("candidate_id", String(record.candidate_id));
      payload.append("actor_due_on", "CANDIDATE");
      payload.append("remarks", replyRemarks.trim());

      replyDocuments.forEach((file) => {
        payload.append("documents", file);
      });

      const res = await insuffResponse.callApi(payload);

      if (res?.success) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your response has been submitted successfully.",
        });

        setReplyRemarks("");
        setReplyDocuments([]);
        setSelectedInsuffRecord(null);
        setShowReplyModal(false);
        await getInsuffHistory();
      } else {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: res?.message || "Unable to submit your response.",
        });
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: error?.message || "Unable to submit your response.",
      });
    }
  };

  useEffect(() => {
    if (candidateId) {
      getInsuffHistory();
    }
  }, [candidateId]);

  const columns = [
    {
      title: "Case ID",
      dataIndex: "case_id",
      key: "case_id",
      width: 120,
    },
    {
      title: "Raise Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (value: string) => formatDate(value),
    },
    {
      title: "Verification Check",
      dataIndex: "check_name",
      key: "check_name",
      width: 180,
      render: (text: string) => (
        <span className="badge bg-info-subtle text-info-emphasis px-3 py-2">
          {text}
        </span>
      ),
    },
    {
      title: "User Type",
      dataIndex: "actor_type",
      key: "actor_type",
      width: 150,
      render: (_: any, record: any) => (
        <div className="fw-bold">{record.actor_type}</div>
      ),
    },
    {
      title: "Submitted By",
      dataIndex: "actor_name",
      key: "actor_name",
      width: 150,
      render: (_: any, record: any) => (
        <div className="fw-bold">{record.actor_name}</div>
      ),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
      width: 350,
    },
    {
      title: "Supporting Docs",
      dataIndex: "documents",
      key: "documents",
      align: "center",
      width: 140,
      render: (documents: any[]) => (
        <button
          className="btn btn-light btn-sm border"
          onClick={() => {
            setSelectedDocuments(documents);
            setShowDocumentsModal(true);
          }}
        >
          <i className="ti ti-eye text-primary me-1"></i>
          View
        </button>
      ),
    },
    {
      title: "Due Date",
      dataIndex: "actor_due_date",
      key: "actor_due_date",
      width: 170,
      render: (value: string) =>
        value ? (
          <span className="text-danger fw-bold">{formatDate(value)}</span>
        ) : (
          "-"
        ),
    },

    {
      title: "Action",
      key: "action",
      align: "center",
      width: 310,
      render: (_: any, record: any) =>
        record?.status === "IN_PROGRESS" && record?.actor_type === "AGENCY" ? (
          <div
            className="d-flex align-items-center justify-content-center gap-2"
            style={{ minWidth: 280 }}
          >
            {/* Application Form */}
            <button
              type="button"
              className="btn btn-warning btn-sm text-dark fw-semibold d-inline-flex align-items-center justify-content-center gap-2"
              style={{
                width: 132,
                minWidth: 132,
                height: 38,
                padding: "6px 10px",
                borderRadius: 6,
                fontSize: 12,
                whiteSpace: "nowrap",
              }}
              onClick={() => {
                if (record.check_name === "Address Verification") {
                  navigate(all_routes.addressInfo, {
                    state: {
                      assignment_template_id: record.assignment_template_id,
                      assignment_id: record.assignment_id,
                      case_id: record.case_id,
                      candidate_id: record.candidate_id,
                      actor_type: record.actor_type,
                    },
                  });

                  return;
                }

                navigate(
                  `${all_routes.superAdminDashboard}?module=${getModuleByCheckName(
                    record.check_name,
                  )}`,
                  {
                    state: {
                      assignment_template_id: record.assignment_template_id,
                      assignment_id: record.assignment_id,
                      case_id: record.case_id,
                      candidate_id: record.candidate_id,
                      actor_type: record.actor_type,
                    },
                  },
                );
              }}
            >
              <i className="ti ti-edit" style={{ fontSize: 14 }} />
              <span>Application Form</span>
            </button>

            {/* Reply to Insufficiency */}
            <button
              type="button"
              className="btn btn-success btn-sm fw-semibold d-inline-flex align-items-center justify-content-center gap-2"
              style={{
                width: 152,
                minWidth: 152,
                height: 38,
                padding: "6px 10px",
                borderRadius: 6,
                fontSize: 12,
                whiteSpace: "nowrap",
              }}
              onClick={() => {
                setSelectedInsuffRecord(record);
                setReplyRemarks("");
                setReplyDocuments([]);
                setShowReplyModal(true);
              }}
            >
              <i className="ti ti-message-circle" style={{ fontSize: 14 }} />
              <span>Reply to Insufficiency</span>
            </button>
          </div>
        ) : (
          "-"
        ),
    },
  ];

  return (
    <>
      {insufftabel.loading ? (
        <SnipperLoader />
      ) : (
        <div>
          {/* ====== Insuff Warning Show ============ */}
          <div className="alert alert-warning border-warning shadow-sm mb-4">
            <div className="d-flex align-items-center">
              <i
                className="ti ti-alert-triangle-filled text-warning me-3"
                style={{ fontSize: 34 }}
              ></i>

              <div>
                <h5 className="mb-1 fw-bold">Action Required</h5>
                <div className="text-muted">
                  The verifier has requested additional information for your
                  verification. Please review the details below and respond
                  before the due date.
                </div>
              </div>
            </div>
          </div>

          <div className="card border">
            <Datatable
              dataSource={insuffHistroy}
              columns={columns}
              Selection={false}
              rowKey="insufficiency_thread_id"
              onRow={(record: any) => ({
                style: {
                  backgroundColor:
                    record.actor_type === "CANDIDATE" ? "#f8f9fa" : "#ffffff",
                },
              })}
            />
          </div>

          {/* ====== Insuff Warning Show ============ */}

          <div
            className={`modal fade ${showDocumentsModal ? "show d-block" : ""}`}
            tabIndex={-1}
            style={{
              backgroundColor: showDocumentsModal
                ? "rgba(0,0,0,0.5)"
                : "transparent",
            }}
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content border-0 shadow">
                {/* Header */}
                <div className="modal-header">
                  <h5 className="modal-title fw-bold">
                    <i className="ti ti-folder-open me-2 text-primary"></i>
                    Uploaded Documents
                  </h5>

                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowDocumentsModal(false)}
                  ></button>
                </div>

                {/* Body */}
                <div className="modal-body">
                  {selectedDocuments.length > 0 ? (
                    <div className="row g-3">
                      {selectedDocuments.map((doc) => (
                        <div className="col-md-6" key={doc.document_id}>
                          <div className="card border h-100">
                            <div className="card-body">
                              <div className="d-flex">
                                {/* Icon */}
                                <div
                                  className="d-flex align-items-center justify-content-center rounded-circle bg-danger-subtle me-3"
                                  style={{
                                    width: 55,
                                    height: 55,
                                    flexShrink: 0,
                                  }}
                                >
                                  <i className="ti ti-file-text text-danger fs-3"></i>
                                </div>

                                {/* Details */}
                                <div className="flex-grow-1">
                                  <h6
                                    className="fw-bold mb-1 text-truncate"
                                    title={doc.original_name}
                                  >
                                    {doc.original_name}
                                  </h6>

                                  <div className="mb-2">
                                    <span className="badge bg-info-subtle text-info-emphasis border border-info-subtle">
                                      {doc.mime_type}
                                    </span>
                                  </div>

                                  <a
                                    href={`${apibaseurl}/uploads/${doc.file_name}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm btn-primary"
                                  >
                                    <i className="ti ti-eye me-1"></i>
                                    View Document
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <i
                        className="ti ti-folder-off text-secondary"
                        style={{ fontSize: "48px" }}
                      ></i>

                      <h6 className="mt-3">No Documents Found</h6>

                      <p className="text-muted mb-0">
                        No supporting documents are available.
                      </p>
                    </div>
                  )}
                </div>

                {/* Footer */}
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowDocumentsModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* ====== Reply to Insuff Modal ============ */}

          {showReplyModal && (
            <div
              className="modal fade show d-block"
              style={{ background: "rgba(0,0,0,.5)" }}
            >
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content border-0 shadow">
                  {/* Header */}
                  <div className="modal-header">
                    <div>
                      <h5 className="modal-title fw-bold mb-1">
                        Respond to Insufficiency
                      </h5>

                      <small className="text-muted">
                        Please provide your explanation and upload supporting
                        documents if applicable.
                      </small>
                    </div>

                    <button
                      className="btn-close"
                      onClick={() => setShowReplyModal(false)}
                    />
                  </div>

                  {/* Body */}
                  <div className="modal-body">
                    {/* Remarks */}
                    <div className="mb-4">
                      <label className="form-label fw-semibold">
                        Remarks
                        <span className="text-danger ms-1">*</span>
                      </label>

                      <textarea
                        rows={5}
                        className="form-control"
                        placeholder="Enter your response to the verifier..."
                        value={replyRemarks}
                        onChange={(e) => setReplyRemarks(e.target.value)}
                        style={{ resize: "none" }}
                      />

                      <small className="text-muted">
                        Clearly explain the requested information or
                        clarification.
                      </small>
                    </div>

                    {/* Upload */}
                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Supporting Documents
                      </label>

                      <input
                        type="file"
                        className="form-control"
                        multiple
                        accept=".jpg,.jpeg,.png,.pdf"
                        onChange={handleReplyFileChange}
                      />

                      <small className="text-muted">
                        Accepted formats: JPG, JPEG, PNG, PDF (Maximum 10 MB per
                        file)
                      </small>
                    </div>

                    {/* Selected Files */}
                    {replyDocuments.length > 0 && (
                      <div className="mt-3">
                        <label className="fw-semibold mb-2">
                          Selected Files
                        </label>

                        <div className="d-flex flex-wrap gap-2">
                          {replyDocuments.map((file, index) => (
                            <span
                              key={index}
                              className="badge rounded-pill bg-success-subtle text-dark border border-success-subtle px-3 py-2 d-flex align-items-center"
                            >
                              <i className="ti ti-paperclip me-2"></i>

                              <span
                                className="text-truncate"
                                style={{ maxWidth: 180 }}
                              >
                                {file.name}
                              </span>

                              <button
                                type="button"
                                className="btn btn-sm border-0 bg-transparent text-danger ms-2 p-0"
                                onClick={() => removeReplyFile(index)}
                              >
                                <i className="ti ti-x"></i>
                              </button>
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Footer */}
                  <div className="modal-footer gap-3">
                    <button
                      className="btn btn-light border"
                      onClick={() => setShowReplyModal(false)}
                    >
                      Cancel
                    </button>

                    <button
                      className="btn btn-primary"
                      onClick={handleSubmitReply}
                      disabled={insuffResponse.loading}
                    >
                      {insuffResponse.loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Submitting...
                        </>
                      ) : (
                        <>
                          <i className="ti ti-send me-2"></i>
                          Submit Response
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default InsuffRaise;
